import React from 'react';
import styled from 'styled-components';
import FacebookImage from './facebook.svg';

const shareUrl = url =>
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    url,
  )}&src=sdkpreparse`;

const ImageIcon = styled.img`
  height: 15px;
  width: 15px;
`;

export default ({url}) => (
  <div
    data-href={url}
    data-layout="button"
    data-size="large"
    data-mobile-iframe="true">
    <a
      href={shareUrl(url)}
      target="_blank"
      className="fb-xfbml-parse-ignore"
      rel="noopener noreferrer">
      <ImageIcon src={FacebookImage} />
    </a>
  </div>
);
